import { createTheme } from "@mui/material/styles";
import { colors, Typography } from "./Variables";

export const muiCustomTheme = createTheme({
    palette: {
      primary: {
        light: colors.lightGreen,
        main: colors.primaryGreen,
        dark: colors.darkGreen,
        contrastText: colors.white,
      },
      secondary: {
        light: colors.lightRed,
        main: colors.secondaryRed2,
        dark: colors.darkRed,
        contrastText: colors.black,
      },
    },
    typography: {
      fontFamily: Typography.primaryFont,
      fontSize: 14,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
    },
  });
  